import { render, staticRenderFns } from "./LfMenuItem.vue?vue&type=template&id=1a7978dc&scoped=true&"
import script from "./LfMenuItem.vue?vue&type=script&lang=js&"
export * from "./LfMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./LfMenuItem.vue?vue&type=style&index=0&id=1a7978dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7978dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\job_hymn\\hymn-business02\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a7978dc')) {
      api.createRecord('1a7978dc', component.options)
    } else {
      api.reload('1a7978dc', component.options)
    }
    module.hot.accept("./LfMenuItem.vue?vue&type=template&id=1a7978dc&scoped=true&", function () {
      api.rerender('1a7978dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LfMenuItem.vue"
export default component.exports